$(document).on('click', 'input[type=\'submit\']#submit-new-pharmacy-group', function(e) {
  $('form#new_pharmacy_group_upload').trigger('submit');

  if($('form#new_pharmacy_group_upload p.red').length < 1) {
    $('<p class="red">If you have a file downloaded, please check it for any errors with provided data.</p>').insertAfter('.file_upload_input_button');
  }
});
